<template>
  <div>
    <!-- <template v-if="qipao">
      <map-home-small v-show="qipao" :qipao="qipao" :coord="coord" :dataList="list" :clockId="clockId" @markclick="(e)=>{$emit('markclick',e)}" />
    </template>
    <template v-if="luxian">
      <map-home-small v-show="luxian" :qipao="qipao" :luxian="luxian" :coord="coord" :clockId="clockId" :dataList="list" :lineList="lineList" @markclick="(e)=>{$emit('markclick',e)}" />
    </template> -->
    <map-home-small ref="maphomes" :qipao="qipao" :luxian="luxian" :coord="coord" :clockId="clockId" :dataList="list" :lineList="lineList" @markclick="(e)=>{$emit('markclick',e)}" />
  </div>
</template>
<script>
import MapHomeSmall from './MapHomeSmall.vue'
export default {

  components: {
    MapHomeSmall,
  },
  name: 'mapHomeVue',
  props: {
    qipao: Boolean,
    luxian: Boolean,
    coord: Array,
    id: String|Number,
    clockId: String|Number,
  },
  data() {
    return {
        list: [],
        lineList: [],
        latlgn: [],
    }
  },
  watch: {
      qipao: {
        handler: function(newv,oldv){
          if(!newv) return;
          if (newv) {
            this.getSpotList();
          }
        },
        immediate: true
    },
      luxian: {
        handler: function(newv,oldv){
          if(!newv) return;
          if (newv) {
            // this.getSpotList();
            // this.getRouteList();
          }
        },
        immediate: true
    },
  },
  mounted(){
    // this.getlocation();

    // this.getSpotList();
    this.getRouteList();
  },
  computed:{

  },
  methods:{
    // 获取定位
    async getlocation(){
      let data = await this.$api.mapApi.getCoordinate();
      let res = data.data;
      let coordinate = this.$utils.map.formatlat(res.latitude);
      // this.latlgn = coordinate;
      this.latlgn = [110.150158,27.342557];
    },
    //获取路线
    async getRouteList(){
      let data = await this.$api.mapApi.getRouteList();
      let list = data.data;
      let lineArr = [];
      list.forEach(item => {
        item.coordinate = this.$utils.map.formatlat(item.coordinate);
        lineArr.push(item.coordinate);
      });
      this.lineList = lineArr;
    },
    //获取景点
    async getSpotList(){
      let that = this;
      let data = await this.$api.mapApi.getSpotList();
      let list = data.data;
      list.forEach(item => {
        if(item.id == that.id){
          item.checked = true;
        }
        item.coordinate = this.$utils.map.formatlat(item.coordinate);
      });
      this.list = list;
    }
  },
}
</script>
<style scoped lang="scss">

</style>

  